import 'css-chunksrc/client/pages/capacityPage/toolbar/granularitySelector/styles.scss';export default {
  "granularitySelector": "_granularitySelector_pm3fb_1",
  "root": "_root_pm3fb_7",
  "input": "_input_pm3fb_11",
  "opened": "_opened_pm3fb_27",
  "icon": "_icon_pm3fb_32",
  "listRoot": "_listRoot_pm3fb_44",
  "list": "_list_pm3fb_44",
  "option": "_option_pm3fb_60",
  "selected": "_selected_pm3fb_66"
};